import { View } from 'react-native'
import Animated from 'react-native-reanimated'
import { TourCatalogCard } from '@/components/tours/TourCatalogCard'
import { TourCardSkeleton } from '@/components/tours/TourCardSkeleton'
import { catalogTileStyle } from '@/lib/tours/catalog-layout'
import type { EntranceFn } from '@/lib/hooks/use-entrance'
import type { TourCatalogExperience } from '@/lib/types/tours.types'

interface ToursCatalogGridProps {
  experiences: TourCatalogExperience[]
  onOpen: (id: string) => void
  columns: number
  gap: number
  enter: EntranceFn
}

export function ToursCatalogGrid({
  experiences,
  onOpen,
  columns,
  gap,
  enter,
}: ToursCatalogGridProps) {
  const tileStyle = catalogTileStyle(columns)

  return (
    <View testID="tours.catalog-grid" style={{ flexDirection: 'row', flexWrap: 'wrap', gap }}>
      {experiences.map((experience, index) => (
        <Animated.View key={experienceId(experience)} entering={enter(index)} style={tileStyle}>
          <TourCatalogCard
            experience={experience}
            onPress={() => onOpen(experience.id)}
            layout="tile"
          />
        </Animated.View>
      ))}
    </View>
  )
}

function experienceId(experience: TourCatalogExperience): string {
  return experience.id
}

export function ToursCatalogGridSkeleton({ columns, gap }: { columns: number; gap: number }) {
  const tileStyle = catalogTileStyle(columns)
  const tileCount = columns * 2

  return (
    <View
      testID="tours.catalog-grid-skeleton"
      style={{ flexDirection: 'row', flexWrap: 'wrap', gap }}
    >
      {Array.from({ length: tileCount }, (_, index) => (
        <View key={index} style={tileStyle}>
          <TourCardSkeleton layout="tile" staggerIndex={index} />
        </View>
      ))}
    </View>
  )
}
